import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="page-footer">
      <div className="container">
        <div className="row">
          <div className="col-md-4 col-sm-12">
            <h1>Santo Cristo de la Piedad</h1>
          </div>
          <div className="col-md-4 col-sm-12">
            <ul className="ul-footer">
              <li><span className="fa fa-envelope-o fa-fw"></span> scristodelapiedad.med@gmail.com</li>
              <li><span className="fa fa-whatsapp fa-fw"></span> 3204337195</li>
              <li><span className="fa fa-map-marker fa-fw"></span> Departamento de Boyacá - Municipio de Pesca</li>
            </ul>
          </div>
          <div className="col-md-4 col-sm-12">
            <ul className="ul-footer">
              <li><Link to="/">Principal</Link></li>
              <li><Link to="/historia">Historia</Link></li>
              <li><Link to="/testimonios">Testimonios</Link></li>
              <li><a href="/#contact">Contactenos</a></li>
              <li><Link to="/agradecimientos">Agradecimientos</Link></li>
              <li><a href="/admin">Administración</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container-fluid page-end">
        <div className="container">
          <div className="row p-3">
            <div className="col-12 col-sm-6">&copy; Santo Cristo de la Piedad 2025, Todos los derechos reservados</div>
            <div className="col-12 col-sm-6 text-right">
              Sitio Web desarrollado por{' '}
              <a href="mailto:natalia.970918@gmail.com">Natalia Díaz</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;